v<template>
	<div id="class" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">Eindresultaten</section>
				</header>
				<div class="section" style="background-color:#eeeeee;padding: 12px;">
					<div class="columns">
						<div class="column is-12">
							<nav class="level">
								<div class="level-left">
									<div class="level-item">
										<b-field label="Schooljaar">
											<b-select
												icon="school"
												placeholder="Kies een school"
												v-model="selected_schoolyear"
											>
												<option v-for="item in schoolyears" :value="item.id" :key="item.id">{{ item.name }}</option>
											</b-select>
										</b-field>
									</div>
									<div class="level-item">
										<b-field label="Norm Papiamentu">
											<b-input
												:loading="loading_norm"
												v-model="cesuur[0].norm"
												:disabled="cesuur[0].locked == 1 ? true: false"
											></b-input>
										</b-field>
									</div>
									<div class="level-item">
										<b-field label="Norm Nederlands">
											<b-input
												:loading="loading_norm"
												v-model="cesuur[1].norm"
												:disabled="cesuur[1].locked == 1 ? true: false"
											></b-input>
										</b-field>
									</div>
									<div class="level-item">
										<b-field label="Norm Rekenen">
											<b-input
												:loading="loading_norm"
												v-model="cesuur[2].norm"
												:disabled="cesuur[2].locked == 1 ? true: false"
											></b-input>
										</b-field>
									</div>
								</div>
							</nav>
						</div>
					</div>

					<div class="columns">
						<div class="column is-12">
							<nav class="level">
								<div class="level-left">
									<div class="level-item">
										<a
											class="button is-primary"
											:disabled="cesuur[0].locked == 1 ? true: false"
											@click="setCesuur()"
										>Norm Bijwerken</a>
									</div>
									<div class="level-item">
										<a
											class="button is-primary"
											@click="calculateResults();"
											:disabled="cesuur[0].locked == 1 ? true: false"
										>Bereken Eindresultaten</a>
									</div>
								</div>
							</nav>
						</div>
					</div>
				</div>

				<div style="padding:5px;">
					<!-- <h4 class="title is-4">Schooljaar {{schoolyear}}</h4> -->
					<b-table
						:data="eindresultaten"
						:bordered="true"
						:narrowed="false"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column label="Uitslag" field="uitslag" width="275">{{ props.row.uitslag }}</b-table-column>
							<b-table-column label="Aantal" field="aantal" width="100">{{ props.row.aantal }}</b-table-column>
							<b-table-column
								label="Percentage"
								field="percentage"
								width="100"
							>{{ props.row.percentage }} %</b-table-column>
						</template>
						<template slot="footer">
							<th class="is-hidden-mobile">
								<div class="th-wrap">Totaal</div>
							</th>
							<th class="is-hidden-mobile">
								<div class="th-wrap">{{total_aantal}}</div>
							</th>
							<th class="is-hidden-mobile">
								<div class="th-wrap">{{total_percentage}} %</div>
							</th>
						</template>
						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation-triangle" size="is-large"></b-icon>
									</p>
									<p>Nothing here.</p>
								</div>
							</section>
						</template>
					</b-table>
				</div>

				<div class="section">
					<h4 class="title is-4">Aantal leerlingen per HAVO scholen</h4>
					<b-table
						:data="eindresultaten_havo"
						:bordered="true"
						:narrowed="false"
						:striped="true"
						:loading="loading_havo"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column label="HAVO" field="havo" width="275">{{ props.row.havo }}</b-table-column>
							<b-table-column label="Aantal" field="aantal" width="100">{{ props.row.aantal }}</b-table-column>
							<b-table-column
								label="Percentage"
								field="percentage"
								width="100"
							>{{ props.row.percentage }} %</b-table-column>
						</template>
						<template slot="footer">
							<th class="is-hidden-mobile">
								<div class="th-wrap">Totaal</div>
							</th>
							<th class="is-hidden-mobile">
								<div class="th-wrap">{{total_aantal_havo}}</div>
							</th>
							<th class="is-hidden-mobile">
								<div class="th-wrap">{{total_percentage_havo}} %</div>
							</th>
						</template>
						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation-triangle" size="is-large"></b-icon>
									</p>
									<p>Nothing here.</p>
								</div>
							</section>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from "axios";
//import Icon from "vue-awesome/components/Icon.vue";
import Cookies from "js-cookie";

import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 6000000
});

export default {
	name: "class",
	created: function() {
		//this.getUnits()
		if (_.isUndefined(this.access == 0)) {
			this.$router.push({
				path: "/"
			});
		}

		this.getSchoolyears();
	},
	data: function() {
		return {
			schoolbestuur: [],
			schoolyears: [],
			n_nederlands: "",
			n_papiaments: "",
			n_rekenenen: "",
			n_locked: false,
			selected_schoolyear: null,
			schoolyear: "",
			eindresultaten: [{}],
			eindresultaten_havo: [{}],
			columns: [{}],
			total_percentage: 0,
			total_aantal: 0,
			total_percentage_havo: 0,
			total_aantal_havo: 0,
			selected_class: null,
			loading_classes: false,
			cesuur: [{}],
			loading: false,
			loading_norm: false,
			loading_havo: false,
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			classes: [],
			isEmpty: false,
			isPaginated: false,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	watch: {
		selected_schoolyear(val) {
			console.log("school_id:" + val);
			//Get cesuur voor de huidige schooljaar

			var self = this;
			this.eindresultaten = [{}];

			instance.get("/cesuur-schoolyear/" + val).then(function(response) {
				console.log("eindresultaten");
				console.log(response.data.data);

				self.cesuur = response.data.data;
				console.log("Selected schoolyear");
				console.log(self.cesuur);
				self.getResultaten();
				self.getResultatenHAVO();
			});
		}
	},
	methods: {
		calculateResults() {
			var self = this;
			this.loading = true;
			instance
				.get("/berekenresultaten/" + this.selected_schoolyear)
				.then(function(response) {
					console.log("eindresultaten");
					console.log(response.data);
					console.log(self.cesuur);
					self.getResultaten();
					self.getResultatenHAVO();
					self.loading = false;
				});
		},
		setCesuur: function() {
			this.loading_norm = true;
			for (let i = 0; i < this.cesuur.length; i++) {
				const element = this.cesuur[i];
				console.log("Set Cesuur");
				console.log(element);

				instance.post("/cesuur/update", element).then(function(response) {
					console.log(response.data.data);
				});
			}
			this.loading_norm = false;
		},
		getResultatenHAVO: function() {
			var self = this;
			this.loading_havo = true;
			self.total_percentage_havo = 0;
			self.total_aantal_havo = 0;
			this.eindresultaten_havo = [{}];
			instance
				.get("/eindresultaten_havo/" + this.selected_schoolyear)
				.then(function(response) {
					console.log("eindresultaten");
					console.log(response.data);

					self.eindresultaten_havo = response.data;

					for (let i = 0; i < self.eindresultaten_havo.length; i++) {
						const element = self.eindresultaten_havo[i];

						self.total_percentage_havo += parseFloat(element.percentage);
						self.total_aantal_havo += element.aantal;
					}
					self.loading_havo = false;
				});
		},
		getResultaten: function() {
			var self = this;
			this.loading = true;
			self.total_percentage = 0;
			self.total_aantal = 0;
			self.eindresultaten = [{}];
			instance
				.get("/eindresultaten/" + this.selected_schoolyear)
				.then(function(response) {
					console.log("eindresultaten");
					console.log(response.data);

					self.eindresultaten = response.data;

					for (let i = 0; i < self.eindresultaten.length; i++) {
						const element = self.eindresultaten[i];

						self.total_percentage += parseFloat(element.percentage);
						self.total_aantal += element.aantal;
					}
					self.loading = false;
				});
		},
		getSchoolboard: function() {
			var self = this;

			instance.get("/schoolboard").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);

				self.schoolbestuur = response.data.data;
			});
		},
		getSchoolyears: function() {
			var self = this;
			self.loading = true;
			instance.get("/schoolyear").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);

				self.schoolyears = response.data.data;

				console.log(self.schoolyears.length);
				var len = self.schoolyears.length;
				var obj = self.schoolyears[len - 1];
				self.selected_schoolyear = obj.id;
				self.schoolyear = obj.name;

				self.loading = false;
			});
		},
		handleClick(studentid) {
			console.log("studentid: " + studentid);
			console.log(this.user.data);
			this.$router.push({
				path: "/studentvoorzitter/" + studentid
			});
		},
		reexamClick(studentid) {
			console.log("studentid: " + studentid);

			this.$router.push({
				path: "reexam/" + studentid
			});
		},
		getSelectedClass: function(id) {
			console.log(id);
			self = this;
			//todo:
			this.loading = true;
			instance.get("/student-class/students/" + id).then(function(response) {
				console.log(response.data.data);

				self.studentData = response.data.data;
				self.loading = false;
			});
		},
		getClasses: function(id) {
			var self = this;

			this.loading_classes = true;
			self.classes = [];
			self.studentData = [];
			instance.get("/class/school/" + id).then(function(response) {
				console.log(response.data.data);
				var obj = response.data.data;

				for (let i = 0; i < obj.length; i++) {
					const element = obj[i];
					console.log(element);
					self.classes.push({
						id: element.id,
						name: element.testgroup + " - " + element.name
					});
				}
				self.selected_class = Cookies.get("selected_class");
				self.loading_classes = false;
			});
		}
	}
};
</script>
<style scoped>
</style>
